const MissingDocument = {
  InputsPanelDescription: "MissingDocument.InputsPanelDescription",
  ReasonForPayment: "MissingDocument.ReasonForPayment",
  ReasonForPaymentDescription: "MissingDocument.ReasonForPaymentDescription",
  ReasonHelpText: "MissingDocument.ReasonHelpText",
  ReasonForTransaction: "MissingDocument.ReasonForTransaction",
  AddPicture: "MissingDocument.AddPicture",
  AddFiles: "MissingDocument.AddFiles",
  PostWithoutPicture: "MissingDocument.PostWithoutPicture",
  PostWithoutPictureDescription: "MissingDocument.PostWithoutPictureDescription",
  Amount: "MissingDocument.Amount",
  Income: "MissingDocument.Income",
  Expense: "MissingDocument.Expense",
  Type: "MissingDocument.Type",
  Types_1: "MissingDocument.Types_1",
  Types_2: "MissingDocument.Types_2",
  Types_3: "MissingDocument.Types_3",
  DocumentType: "MissingDocument.DocumentType",
  From: "MissingDocument.From",
  Account: "MissingDocument.Account",
  LockedFilesReason: "MissingDocument.LockedFilesReason",
  SentBack: "MissingDocument.SentBack",
  SentBackDescription: "MissingDocument.SentBackDescription",
  BankInformation: "MissingDocument.BankInformation",
  CounterpartyName: "MissingDocument.CounterpartyName",
  CounterpartyAccountType: "MissingDocument.CounterpartyAccountType",
  CounterpartyAccount: "MissingDocument.CounterpartyAccount",
  CounterpartyOrgNumber: "MissingDocument.CounterpartyOrgNumber",
  EndToEndId: "MissingDocument.EndToEndId",
  Reference: "MissingDocument.Reference",
  Currency: "MissingDocument.Currency",
  AmountInCurrency: "MissingDocument.AmountInCurrency",
  ExchangeRate: "MissingDocument.ExchangeRate",
  }
export default MissingDocument;